export enum PreviewType {
    WEBSITE = 1,
    IMAGE = 2,
    VIDEO = 3,
    GIF = 4,
    FILE = 5,
    AUDIO = 6
}